/**
 * All global scripts
 */

document.addEventListener('DOMContentLoaded', (event) => {

    const header = document.getElementById('header');

    // header fixed
    if ( window.innerWidth > 1200 && header ) {

        window.addEventListener('scroll', function() {
            if(window.scrollY){
                header.classList.add('fixed');
            }
            else{
                header.classList.remove('fixed');
            }
        });
    };
    // END header scripts

	// MENU MOBILE
	if ( window.innerWidth < 992 ) {

		const menu = new Mmenu( '#menu', {
			"offCanvas": {
			   "position": "right"
			},
			"navbar": {
				"title": "Menu"
			},
		});

		const mainMenu = document.querySelector( '#main-menu');
		const secondaryMenu = document.querySelector( '#secondary-menu');

		if (mainMenu && secondaryMenu) {
			// Déplace le menu secondaire juste après le menu principal
			mainMenu.insertAdjacentElement('beforeend', secondaryMenu);
		}

		const api = menu.API;

		document.querySelector( "#menu__toggle" ).addEventListener( "click", (event) => {
			if ( document.body.classList.contains('mm-wrapper--opened')) {
				api.close();
			} else {
				api.open();
			}
		});
	}

}); // end DOMContentLoaded

